import { IsNotEmpty } from 'class-validator';

export class SenderName {
  id: string;

  @IsNotEmpty({ message: 'Please enter an email name' })
  address: string;

  @IsNotEmpty({ message: 'Please enter a sender name' })
  senderName: string;
}

export default SenderName;
